module.exports = "img/flags/ES.10d63db.png";